import React, { useEffect, useState } from 'react';
import useGlobale from './global';

const AuthProvider = ({ children }) => {
    const { checkAuth } = useGlobale();
    const [isInitialized, setIsInitialized] = useState(false);

    useEffect(() => {
        const initializeAuth = async () => {
            try {
                await checkAuth();
            } catch (error) {
                console.error('Failed to initialize authentication:', error);
            } finally {
                setIsInitialized(true);
            }
        };

        initializeAuth();
    }, [checkAuth]);

    // Afficher un loader pendant l'initialisation
    if (!isInitialized) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 to-green-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-orange-500 mx-auto mb-4"></div>
                    <p className="text-gray-600 text-lg">Chargement...</p>
                </div>
            </div>
        );
    }

    return children;
};

export default AuthProvider;